import * as React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import toastr from 'toastr';
import store from './config/store';
import uiRoutes from './config/routes';

import 'bootstrap';
import 'metismenu';
//node-modules-css
import 'toastr/build/toastr.css';
import 'qtip2/dist/jquery.qtip.css';
import 'animate.css/animate.min.css';
import 'flatpickr/dist/flatpickr.css';
import 'jquery-datetimepicker/jquery.datetimepicker.css'
import 'jquery-ui-dist/jquery-ui.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-tagsinput/react-tagsinput.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery.splitter/css/jquery.splitter.css';
import 'jquery-timepicker/jquery.timepicker.css';
import 'bootstrap-toggle/css/bootstrap-toggle.css';
import 'jquery-confirm/dist/jquery-confirm.min.css';
//node-modules-js
import 'jquery/dist/jquery.min.js'
import 'jquery-ui-dist/jquery-ui.min.js';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.js'
import 'qtip2/dist/jquery.qtip.js';
import 'flatpickr/dist/flatpickr.js';
import 'jquery.splitter/js/jquery.splitter.js';
import 'jquery-timepicker/jquery.timepicker.js';
import 'bootstrap-toggle/js/bootstrap-toggle.js';
import 'jquery-confirm/dist/jquery-confirm.min.js';
//public-modules-css
import '../public/styles/app.css';
import '../public/styles/style.css';
import '../public/modules/select2-3.5.3/select2.css';
import '../public/modules/slickgrid/css/plugins-common.css';
import '../public/modules/slickgrid/css/slick-grid-custom.css';
import '../public/modules/slickgrid/css/plugins-gdoc-style.css';
import '../public/modules/slickgrid/css/slick.headerbuttons.css';
import '../public/modules/jquery-liteaccordion/css/liteaccordion.css';
import '../public/modules/slickgrid/slickgrid-column-group-master/dist/slick.columngroup.css';
//public-modules-js
import '../public/modules/select2-3.5.3/select2.js';
import '../public/modules/slickgrid/js/ext.overlays';
import '../public/modules/slickgrid/js/ext.headerfilter.js';
import '../public/modules/slickgrid/js/slick.radioselectcolumn.js';
import '../public/modules/jquery-liteaccordion/js/liteaccordion.jquery.js';
import '../public/modules/slickgrid/slickgrid-column-group-master/dist/slick.columngroup.js';
//slick-grid-js-css
import 'slickgrid/slick.grid.css';
import 'slickgrid/css/smoothness/jquery-ui-1.11.3.custom.css';
import 'slickgrid/controls/slick.columnpicker.css';
import 'slickgrid/lib/firebugx.js';
import 'slickgrid/lib/jquery-1.11.2.min.js';
import 'slickgrid/lib/jquery.event.drag-2.3.0.js';
import 'slickgrid/lib/jquery.event.drop-2.3.0';
import 'slickgrid/slick.groupitemmetadataprovider';
import 'slickgrid/slick.formatters.js';
import 'slickgrid/slick.dataview.js';
import 'slickgrid/slick.editors.js';
import 'slickgrid/slick.core.js';
import 'slickgrid/slick.grid.js';
import 'slickgrid/plugins/slick.rowselectionmodel.js';
import 'slickgrid/plugins/slick.checkboxselectcolumn.js';
import 'slickgrid/plugins/slick.autotooltips.js';
import 'slickgrid/plugins/slick.cellrangedecorator.js';
import 'slickgrid/plugins/slick.cellrangeselector.js';
import 'slickgrid/plugins/slick.cellcopymanager.js';
import 'slickgrid/plugins/slick.cellselectionmodel.js';
import 'slickgrid/plugins/slick.rowmovemanager';
import 'slickgrid/plugins/slick.headerbuttons.js';
import 'slickgrid/controls/slick.columnpicker.js';
import {LicenseManager} from "ag-grid-enterprise";

import Utils from "./Utils";

let url = Utils.API_BASE_URL;
if (url.endsWith(Utils.API_BASE_URL_V1_POSTFIX)) {
    url = url.substring(0, url.length - Utils.API_BASE_URL_V1_POSTFIX.length);
}

LicenseManager.setLicenseKey("CompanyName=Panaton Software,LicensedGroup=Dejan Nenov,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-009351,ExpiryDate=19_August_2021_[v2]_MTYyOTMyNzYwMDAwMA==82b32b55e261629a41da0565e18352cc");

toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 5000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

declare global {
    interface Array<T> {
        containsSome(arr: string[]): boolean;
    }
}
/*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
Array.prototype.containsSome = function (arr: string[]): boolean {
    for (let item of arr) {
        if (this.includes(item)) {
            return true;
        }
    }
    return false
};

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            {uiRoutes()}
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

console.error = (function () {
    const error = console.error;
    return function (exception) {
        if (exception !== 'ag-Grid: unable to find bean reference agGridReact while initialising frameworkComponentWrapper') {
            error.call(console, exception);
        }
    }
})();



// WEBPACK FOOTER //
// ./app/index.tsx